import React, { memo } from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../Button/index'
import Check from '../../../../Icon/icons/Check/index'

/**
 * Shared "Done" button used by the three editable `PlaylistRow` variants:
 * `EditableMyPlaylistRow`, `SystemPlaylistShellRow`, and
 * `SystemPlaylistExternalRow`. Each variant slots this into the
 * `<PlaylistRow.Header>` `nameAction` position when edit mode is active.
 *
 * Wrapped in `React.memo` so the surrounding `useMemo` cells in each
 * variant can pass the same element across renders without re-allocating.
 */
export interface RowEditDoneButtonProps {
  onClick: () => void
  label: string
}

function RowEditDoneButton ({ onClick, label }: RowEditDoneButtonProps) {
  return (
    <Button
      type={BUTTON_TYPES.GHOST}
      className="profile-my-playlists__sharing-badge profile-my-playlists__sharing-badge--shared"
      onClick={onClick}
    >
      <Check />
      {label}
    </Button>
  )
}

export default memo(RowEditDoneButton)
